import { RefreshCw } from 'lucide-react';
import { Alert } from './ui/Alert';
import { Button } from './ui/Button';

export function ReadFailure({ message, retry }: { message: string; retry: () => void }) {
  return (
    <Alert tone="error">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <span>{message}</span>
        <Button type="button" variant="outline" size="sm" icon={RefreshCw} onClick={retry}>Try again</Button>
      </div>
    </Alert>
  );
}
